// Technical bounds of synchronous reports; these are not employment rules.
export function reportRangeError(from, to) {
  const validDate = (value) => {
    if (typeof value !== "string" || !/^\d{4}-\d{2}-\d{2}$/.test(value)) return false;
    const year = Number(value.slice(0, 4));
    const epoch = Date.parse(`${value}T00:00:00Z`);
    return year >= 1900 && year <= 9998 && Number.isFinite(epoch) && new Date(epoch).toISOString().slice(0, 10) === value;
  };
  if (!validDate(from) || !validDate(to)) return "Podaj rzeczywiste daty z lat 1900–9998.";
  if (from > to) return "Data końcowa nie może poprzedzać początkowej.";
  if ((Date.parse(`${to}T00:00:00Z`) - Date.parse(`${from}T00:00:00Z`)) / 86_400_000 + 1 > 366) {
    return "Zakres raportu może obejmować najwyżej 366 dni. Wybierz krótszy okres.";
  }
  return null;
}
